import { createElementObject, createPathComponent, extendContext } from './core';
// import { Polygon as LeafletPolygon } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { LatLngExpression, Polygon as LeafletPolygonInstance, PolylineOptions } from '@anlan/gs-map';
import type { ReactNode } from 'react';
import type { LeafletContextInterface, PathProps } from './core';
const LeafletPolygon = L.Polygon;

export interface PolygonProps extends PolylineOptions, PathProps {
    children?: ReactNode
    positions: LatLngExpression[] | LatLngExpression[][] | LatLngExpression[][][]
}

export const Polygon = createPathComponent(function createPolygon({ positions, ...options }: PolygonProps, ctx: LeafletContextInterface) {
    const polygon = new LeafletPolygon(positions, options);
    return createElementObject(polygon, extendContext(ctx, {
        overlayContainer: polygon
    }));
}, function updatePolygon(layer: LeafletPolygonInstance, props: PolygonProps, prevProps: PolygonProps) {
    if (props.positions !== prevProps.positions) {
        layer.setLatLngs(props.positions);
    }
});
